import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import moment from 'moment';

export const TABLE_PAGE_INIT = '1';
export const TABLE_PAGE_SIZE = '10';
export const FACE_MANAGER = 'FACE_MANAGER';
export const THRESHOLD_DEFAULT = 0.85;

export const DATA_SETTING = {
  username: 'nabla_face_app',
  roleType: 'coOwner',
};

export const DatePattern = {
  DATE: 'YYYY-MM-DD',
  TIME: 'HH:mm:ss',
  DATE_TIME: 'YYYY-MM-DD HH:mm:ss',
  TIMESTAMP: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  MONTH_DATE: 'MM-DD',
  UTC_DATE: 'YYYY-MM-DD[T]HH:mm:ss',
};

export const formatDate = (date = moment(), format = DatePattern.DATE) => {
  if (!date.isValid()) return '';
  return moment(date).format(format);
};

export const convertDateUTCToLocal = (
  utcString: string,
  format = DatePattern.DATE
) => {
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return dayjs.utc(utcString).tz(clientTimeZone).format(format);
};

export const saveKeyToLocalStorage = (storageKey: string, value: string) => {
  const encrypted = CryptoJS.AES.encrypt(
    value,
    process.env.REACT_APP_SECRET_KEY ?? ''
  ).toString();
  localStorage.setItem(storageKey, encrypted);
};

export const getKeyFromLocalStorage = (storageKey: string): string => {
  const encrypted = localStorage.getItem(storageKey);
  if (!encrypted) return '';

  try {
    const bytes = CryptoJS.AES.decrypt(
      encrypted,
      process.env.REACT_APP_SECRET_KEY ?? ''
    );
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Decoding failed', e);
    return '';
  }
};

export const removeKeyFromLocalStorage = (storageKeys: string[]) => {
  storageKeys.forEach((storageKey) => localStorage.removeItem(storageKey));
};

export const generateUuid = () => {
  let username = getKeyFromLocalStorage('username');
  if (!username) {
    username = window.crypto.randomUUID();
    saveKeyToLocalStorage('username', username);
  }
  return username;
};
